import {
  IS_REORDERABLE_FALSE,
  PRODUCT_KEY_MISSING,
  REORDER_NOT_PERMITTED,
  RETIRED_PRODUCT,
} from './newRelic';

/* list of statuses from the reorder response which will trigger the "This product is not available" feedback banner */
export const reorderUnavailableFailureReasons = [
  PRODUCT_KEY_MISSING,
  REORDER_NOT_PERMITTED,
  RETIRED_PRODUCT,
  IS_REORDERABLE_FALSE,
];
